import { StudentAgreementsTab } from '@features/student-agreements/components/StudentAgreementsTab'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/students/$studentNo/student-agreements')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Student Agreements',
        },
    },
})

function RouteComponent() {
    const { studentNo } = Route.useParams()
    return <StudentAgreementsTab studentNo={studentNo} />
}
